import { EventEmitter } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ConfigService } from "./config.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class EventPlanCapacitacionService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.jsonContent = {
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                Authorization: sessionStorage.getItem("batoken"),
                User: sessionStorage.getItem("userid"),
            }),
        };
        this.invokeFirstComponentFunction = new EventEmitter();
        this.headers = new HttpHeaders();
    }
    insertPlanCapacitacion(capacitacion, userId) {
        let listaCapacitaciones = [];
        for (let caps of capacitacion) {
            let cap = new Map();
            cap.set("anio", caps[0]);
            cap.set("proceso", caps[1]);
            cap.set("nombreFoco", caps[2]);
            cap.set("nombreCategoria", caps[3]);
            cap.set("cantidad", caps[4]);
            cap.set("peso", caps[5]);
            cap.set("usuarioId", userId);
            let obj = Array.from(cap).reduce((obj, [key, value]) => Object.assign(obj, { [key]: value }), {});
            listaCapacitaciones.push(obj);
        }
        let capacitaciones = JSON.stringify(listaCapacitaciones);
        return this.http
            .post(`${this.configService.API_URL}/capacitaciones/crear-plan-capacitacion`, capacitaciones, Object.assign({}, this.jsonContent, { responseType: "text" }))
            .toPromise();
    }
}
EventPlanCapacitacionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventPlanCapacitacionService_Factory() { return new EventPlanCapacitacionService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: EventPlanCapacitacionService, providedIn: "root" });
